<template>
  <div class="not-valid">
    <div class="row">
      <div class="col-8">
        <h4>Lead Information</h4>
        <div v-if="consumerErrors.length > 0">
          <div v-for="error in stringErrors" :key="error">
            {{error}}
          </div>
          <div v-if="hiddenFieldErrors.length > 0">
            <span class="fw-bold">Alert:</span> The value passed into the portal isn't accepted per the portal settings in leadHOOP.  Please review your settings and feel free to reach out to your leadHOOP representative.
            <br /><br />
            <div v-for="error in hiddenFieldErrors" :key="error.field">
              <div v-if="error.errorMsg && error.errorMsg.length > 0">
                <span class="fw-bold">{{error.field}}:</span> {{ error.errorMsg }}
              </div>
              <div v-else>
                <span class="fw-bold">Field:</span> {{error.field}}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          Sorry, based on the information provided, this consumer does not qualify for any offers.
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'NotValid',
  props: ['consumerId'],
  computed: {
    stringErrors () {
      return this.consumerErrors.filter((e) => typeof e === 'string')
    },
    hiddenFieldErrors () {
      return this.consumerErrors.filter((e) => typeof e !== 'string' && e.type === 'HiddenFieldError')
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      consumerErrors: state => state.consumer.consumerErrors
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded'
    })
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
